var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"watermark",rawName:"v-watermark",value:(_vm.watermarkOptions),expression:"watermarkOptions"}],staticClass:"base supper-app-base",attrs:{"id":"base-app"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }